import './Sidebar.css';

function Sidebar({ sections, activeId, onItemClick, isOpen, onClose }) {
  return (
    <>
      {isOpen && <div className="sidebar-backdrop" onClick={onClose} />}
      <aside
        className={`profile-sidebar ${isOpen ? 'open' : ''}`}
        aria-label="Page sections"
        aria-hidden={!isOpen}
      >
        <button
          className="sidebar-close"
          onClick={onClose}
          aria-label="Close navigation"
        >
          [ × ]
        </button>
        <nav className="sidebar-list">
          {sections.map((s) =>
            s.isBreaker ? (
              <div key={`break-${s.lineNumber}`} className="sidebar-item breaker">
                <span className="sidebar-lineno">{s.lineNumber}</span>
                <span />
              </div>
            ) : (
              <a
                key={s.id}
                href={`#${s.id}`}
                className={`sidebar-item ${activeId === s.id ? 'active' : ''}`}
                onClick={(e) => {
                  e.preventDefault();
                  onItemClick(s.id);
                }}
                tabIndex={isOpen ? 0 : -1}
              >
                <span className="sidebar-lineno">{s.lineNumber}</span>
                <span className="sidebar-label">{s.label}</span>
              </a>
            )
          )}
        </nav>
        <div className="sidebar-footer">
          <a
            href="/feedback"
            className="sidebar-support"
            tabIndex={isOpen ? 0 : -1}
          >
            Feedback
          </a>
          <a
            href="https://ko-fi.com/oddlobster"
            className="sidebar-support"
            target="_blank"
            rel="noopener noreferrer"
            tabIndex={isOpen ? 0 : -1}
          >
            Support me with ☕
          </a>
        </div>
      </aside>
    </>
  );
}

export default Sidebar;
